import { InjectionToken } from "@angular/core";

export interface AccountJwtConfig {
  domain: string;
  name: string;
}

export const ACCOUNT_JWT_CONFIG = new InjectionToken<AccountJwtConfig>(
  "account-jwt-config"
);
